module.exports = __webpack_public_path__ + "img/powerpoint.71758848.svg";